import { Component, EventEmitter, Output } from '@angular/core'

import { BookingHubSessionSettingsComponent } from '../booking-hub-session-settings/booking-hub-session-settings.component'
import { BookingHubScheduleFormComponent } from '../booking-hub-schedule-form/booking-hub-schedule-form.component'
import { NowSessionsSidebarComponent } from '@app/calendar/components/now-sessions-sidebar/now-sessions-sidebar.component'
import { ScrollPanelModule } from 'primeng/scrollpanel'
import { ButtonModule } from 'primeng/button'

@Component({
    selector: 'fm-booking-hub',
    imports: [
        ButtonModule,
        ScrollPanelModule,
        BookingHubScheduleFormComponent,
        BookingHubSessionSettingsComponent,
        NowSessionsSidebarComponent,
    ],
    templateUrl: './booking-hub.component.html',
    styleUrl: './booking-hub.component.scss',
})
export class BookingHubComponent {
    public showScheduleForm = false
    public showFocusNowForm = false
}
